module.exports = __webpack_public_path__ + "static/media/SignUp5Wave.a3997f6f.svg";